//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {rsaEncryFn} from "@/utils/commons";

export default {
  name: "register-login",
  data(){
    return{
      phone:null,
      login:null,
      email:null,
      checkKey:null,
      activationForm:{}
    }
  },
  methods:{
    backLastPage(){
      this.$router.go(-1);
    },
    validatePass(rule, value, callback){
      if (this.activationForm.againPassword) {
        this.$refs.activationForm.validateField('againPassword');
      }
      callback();
    },
    againPasswordValid(rule, value, callback){
      if (value && (value !== this.activationForm.password)) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },
    //根据checkKey获取账号信息
    getMsgByCheckkey(){
      this.$loadingShow();
      this.$get('api/before-login/active-check?_allow_anonymous=true',{checkKey:this.checkKey}).then((data) => {
        if(data){
          this.login = data.login;
          this.email = data.email;
          this.phone = data.phone;
        }
        this.$loadingHide();
      }).catch(()=>this.$loadingHide());
    },
    goLogin(){
      this.$refs['activationForm'].validate((valid) => {
        if(!valid){
          return;
        }
        this.activationForm.checkKey = this.checkKey;
        this.activationForm.login = this.login;
        this.activationForm.phone = this.phone;
        this.activationForm.email = this.email;
        this.$put('api/user/checkPsw?_allow_anonymous=true?',rsaEncryFn(this.activationForm.password)).then((res)=>{
          if(res){
            if(res.status !== 'success'){
              this.$vux.toast.text(res.msg);
            }else{
              this.$post('api/before-login/active?_allow_anonymous=true',this.activationForm).then(() => {
                let loginObj = {
                  username:this.login,
                  password:this.activationForm.password,
                  rememberMe: true
                };
                this.$loadingShow();
                if (loginObj.password) {
                  loginObj.password = rsaEncryFn(loginObj.password);
                }
                this.$post('api/authenticate/?_allow_anonymous=true',loginObj).then((result) => {
                  this.$loadingHide();
                  if (result != null && result.status === "errorUsername"){
                    if(this.loginWay === 'phone'){
                      this.$vux.toast.text('手机号码或验证码错误,请重新输入');
                    }else{
                      this.$vux.toast.text('登录账户名或密码错误,请重新输入');
                    }
                    return;
                  }
                  if (result != null && result.status === "errorPassword"){
                    if(this.loginWay === 'phone'){
                      this.$vux.toast.text('手机号码或验证码错误,请重新输入');
                    }else{
                      this.$vux.toast.text('登录账户名或密码错误,请重新输入');
                    }
                    return;
                  }
                  if (result != null && result.status === "lock"){
                    this.$vux.toast.text('此账号被锁定,解锁时间：' + result.msg.unLockTime);
                    return;
                  }
                  if (result != null && result.status === "invalid"){
                    this.$vux.toast.text('此用户未在可用期限内');
                    return;
                  }
                  localStorage.setItem('_token',"Bearer " + result.msg.id_token);
                  this.getCurrent();
                  this.$router.push('/');
                }).catch(() => {
                  this.$loadingHide();
                })
              })
            }
          }
        })
      });
    },
    //  获取当前用户信息
    getCurrent(){
      this.$get('api/person/current').then((data) => {
        this.$store.dispatch('commitChangeType',data.userType);
        this.$store.dispatch('commitChangeUserId',data.id);
        if(this.$store.state.userType == '1'){
          this.$store.dispatch('commitChangeSupId',null);
        }else{
          this.$get('api/supplier/current-sample').then((res) => {
            this.$store.dispatch('commitChangeSupId',res.id);
          })
        }
      })
    },
  },
  mounted(){
    this.checkKey = this.$route.params.checkKey;
    this.phone = this.$route.params.phone;
    this.getMsgByCheckkey();
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier/register/register-login.vue